<script>
    import { _ } from 'svelte-i18n';
    import axios from 'axios';
    import { url } from '../stores/url.js';
    import { roles } from '../stores/roles.js'; 
    import { users } from '../stores/users.js'; 
    import { permissions } from '../stores/permissions.js'; 
    import { swalConfirm } from '../functions/html-helpers.js';
    import { request  } from '../functions/http-helpers.js'

    let view = 'overview';
    let bv_search = '';
    let select_role = '';
    let keyup_search_timeout = null;
    let filtered_users = $users;

    console.log(filtered_users)



    /* Events */
    function keyupSearch() {
        clearTimeout(keyup_search_timeout);
        keyup_search_timeout = setTimeout(() => {
            search();
        }, 500);
    }   
    

    function search() {
        filtered_users = $users.filter(u => u.firstname.includes(bv_search) || u.lastname.includes(bv_search) || u.email.includes(bv_search));
    }



    /* POST */
    async function addRole(user_id) {
        if(select_role) {
            const [data, error] = await request('put', `${$url}/user/add_role/${user_id}`, {
                role_id: select_role
            });
            if(!error) {
                filtered_users.find(u => u.id == user_id).roles_pivot = data.roles_pivot;
                filtered_users = filtered_users;
            }
        }
    }


 
    /* DELETE */
    async function removeUserRole(user_id, role_id) {
        const confirmed = await swalConfirm('confirm_remove_user_role_1', 'confirm_remove_user_role_2', 'warning', $_('yes'));
        if(confirmed) {
            const [data, error] = await request('put', `${$url}/user/remove_role/${user_id}`, {
                role_id: role_id
            });
            if(!error) {
                filtered_users.find(u => u.id == user_id).roles_pivot = data.roles_pivot;
                filtered_users = filtered_users;
            }   
        }
    }


</script>


<div class="uk-container">
    <div class="uk-card uk-card-default uk-card-body uk-margin-top">
        <h3>{$_('users')}</h3>

        <input type="text" class="uk-input" placeholder="{$_('search')}..." bind:value={bv_search} on:keyup={() => keyupSearch()} />

        <table class="uk-table uk-table-striped uk-table-small uk-table-middle">
            <thead>
                <tr>
                    <th>
                        <span class="th-sort-icon" uk-icon=""></span>
                        {$_('firstname')}
                    </th>
                    <th>
                        <span class="th-sort-icon" uk-icon=""></span>
                        {$_('lastname')}
                    </th>
                    <th>
                        <span class="th-sort-icon" uk-icon=""></span>
                        {$_('email')}
                    </th>
                    <th style="width: 400px;">
                        {$_('roles')}
                    </th>
                    <th style="width: 60px;">

                    </th>
                </tr>
            </thead>
            <tbody>
                {#each filtered_users as user}
                    <tr>
                        <td data-sort={user.firstname}>
                            {user.firstname}
                        </td>
                        <td data-sort={user.lastname}>
                            {user.lastname}
                        </td>
                        <td data-sort={user.email}>
                            {user.email}
                        </td>
                        <td style="width: 400px;">
                            <ul class="uk-subnav uk-subnav-pill uk-margin-remove-bottom" style="display: inline-flex;">
                                {#each user.roles_pivot as role_pivot}
                                    <li class="uk-active">
                                        <a on:click={() => removeUserRole(user.id, role_pivot.role.id)}>
                                            {role_pivot.role.name}
                                        </a>
                                    </li>
                                {/each}
                            </ul>
                            <select class="uk-select uk-form-small uk-margin-left" style="width: 100px;" bind:value={select_role} on:change={() => addRole(user.id)}>
                                <option value="">{$_('assign')}</option>
                                {#each $roles as role}
                                    {#if !user.roles_pivot.filter(rp => rp.role.id == role.id).length}
                                        <option value={role.id}>
                                            {role.name}
                                        </option>
                                    {/if}
                                {/each}
                            </select>
                            
                        </td>
                        <td class="uk-text-right">
                            {#if view == 'overview'}
                                <span class="uk-margin-small-right c-pointer" uk-tooltip={$_('edit')} uk-icon="pencil" on:click={() => editUser(user)}></span>
                                <span class="uk-text-danger c-pointer" uk-tooltip={$_('remove')} uk-icon="trash" on:click={() => removeUser(user)}></span>
                            {/if}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
   
</div>